module.exports = __webpack_public_path__ + "img/city-back.177043f5.webp";